import { defineMessages } from 'dibs-react-intl';

// components
import { SbRespRefineMenuFilterPrice } from './SbRespRefineMenuFilterPrice.tsx';
import { SbRespRefineMenuFilterCategory } from './SbRespRefineMenuFilterCategory.jsx';
import { SbRespRefineMenuFilterStoneCut } from './SbRespRefineMenuFilterStoneCut.jsx';
import { SbRespRefineMenuFilterDimensions } from './SbRespRefineMenuFilterDimensions.jsx';
import { SbRespRefineMenuFilterCaratWeight } from './SbRespRefineMenuFilterCaratWeight.jsx';
import { SbRespRefineMenuFilterArtSize } from './SbRespRefineMenuFilterArtSize.tsx';
import { SbSharedRefineMenuFilterItemLocation } from '../../SbSharedRefineMenu/SbSharedRefineMenuFilters/SbSharedRefineMenuFilterItemLocation.tsx';
import { SbSharedRefineMenuFilterDeliveryOptions } from '../../SbSharedRefineMenu/SbSharedRefineMenuFilters/SbSharedRefineMenuFilterDeliveryOptions.jsx';
import { sbSharedRefineMenuFiltersMap } from '../../SbSharedRefineMenu/SbSharedRefineMenuFilters/sbSharedRefineMenuFiltersMap.js';
import { type RefineMenuFiltersMap } from '../../../utils/tracking/searchBrowse/getPageviewData.ts';

const titleOverrides = defineMessages({
    dimensions: {
        id: 'sb.SbRespRefineMenuFilterDimension.title',
        defaultMessage: 'Dimensions',
    },
    shippingOptions: {
        id: 'sb.SbRespRefineMenuFilterDeliveryOptions.title',
        defaultMessage: 'Shipping Options',
    },
    itemLocation: {
        id: 'sb.SbRespRefineMenuFilterItemLocation.title',
        defaultMessage: 'Item Location',
    },
});

export const sbRespRefineMenuFiltersMap: RefineMenuFiltersMap = {
    ...sbSharedRefineMenuFiltersMap,
    categoryL1: {
        component: SbRespRefineMenuFilterCategory,
    },
    'carat-weight': {
        component: SbRespRefineMenuFilterCaratWeight,
    },
    'art-size': {
        component: SbRespRefineMenuFilterArtSize,
    },
    height: {
        component: SbRespRefineMenuFilterDimensions,
        title: titleOverrides.dimensions,
    },
    width: {
        component: SbRespRefineMenuFilterDimensions,
        title: titleOverrides.dimensions,
    },
    length: {
        component: SbRespRefineMenuFilterDimensions,
        title: titleOverrides.dimensions,
    },
    depth: {
        component: SbRespRefineMenuFilterDimensions,
        title: titleOverrides.dimensions,
    },
    price: {
        component: SbRespRefineMenuFilterPrice,
    },
    priceTrade: {
        component: SbRespRefineMenuFilterPrice,
    },
    'stone-cut': {
        component: SbRespRefineMenuFilterStoneCut,
    },
    latest: {
        component: null,
        isBatchAppliedFilter: true,
    },
    shippingOptions: {
        component: SbSharedRefineMenuFilterDeliveryOptions,
        title: titleOverrides.shippingOptions,
    },
    location: {
        component: SbSharedRefineMenuFilterItemLocation,
        title: titleOverrides.itemLocation,
    },
    sale: {
        component: null,
        isBatchAppliedFilter: true,
    },
    'new-arrivals': {
        component: null,
        isBatchAppliedFilter: true,
    },
    customizable: {
        component: null,
        isBatchAppliedFilter: true,
    },
    'net-price': {
        component: null,
        isBatchAppliedFilter: true,
    },
    returnable: {
        component: null,
        isBatchAppliedFilter: true,
    },
    recognized: {
        component: null,
        isBatchAppliedFilter: true,
    },
    topSeller: {
        component: null,
        isBatchAppliedFilter: true,
    },
    isSellerStrategicPartner: {
        component: null,
        isBatchAppliedFilter: true,
    },
    view: {
        component: null,
        isBatchAppliedFilter: true,
    },
};

export const isBatchAppliedFilter = (filterName: string): boolean =>
    sbRespRefineMenuFiltersMap[filterName] &&
    !!sbRespRefineMenuFiltersMap[filterName]?.isBatchAppliedFilter;
